export const PWA_UPDATE_RELOAD_TIMEOUT_MS = 8000

/**
 * Activa el service worker en espera y recarga esta ventana cuando cambia el
 * controlador. El timeout evita que el reproductor quede indefinidamente en
 * "Actualizando..." si el navegador no emite controllerchange.
 */
export function applyServiceWorkerUpdate({
  updateServiceWorker,
  serviceWorker,
  reload,
  timeoutMs = PWA_UPDATE_RELOAD_TIMEOUT_MS,
  schedule = setTimeout,
  cancel = clearTimeout
}) {
  return new Promise((resolve, reject) => {
    let finished = false
    let timeoutId = null

    const cleanup = () => {
      if (timeoutId !== null) cancel(timeoutId)
      serviceWorker?.removeEventListener?.('controllerchange', finish)
    }

    const finish = () => {
      if (finished) return
      finished = true
      cleanup()
      reload()
      resolve()
    }

    serviceWorker?.addEventListener?.('controllerchange', finish)
    timeoutId = schedule(finish, timeoutMs)

    Promise.resolve(updateServiceWorker(false)).catch(error => {
      if (finished) return
      finished = true
      cleanup()
      reject(error)
    })
  })
}
